import { render, staticRenderFns } from "./ZwiflocTabs.vue?vue&type=template&id=1aa4ce9d&scoped=true"
import script from "./ZwiflocTabs.vue?vue&type=script&lang=js"
export * from "./ZwiflocTabs.vue?vue&type=script&lang=js"
import style0 from "./ZwiflocTabs.vue?vue&type=style&index=0&id=1aa4ce9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4ce9d",
  null
  
)

export default component.exports